import { useSsh } from "./context"
import { createSshRestore } from "./restore-state"
import { fixedRemoteProjectID } from "./name"

export function SshRestore() {
  const ssh = useSsh()
  createSshRestore({
    state: () => ({ servers: ssh.servers.filter((item) => item.config.id !== fixedRemoteProjectID) }),
    start: ssh.restore,
  })
  return null
}
